/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const CardHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--panel-divider);
  margin-left: 1em;
  padding: 0.875em 0.875em 0.875em 0em;
`;

export const PanelCardHeader = styled.div`
  font-size: 0.875em;
  font-weight: 600;
  color: var(--text-soft-mute);
`;

export const CardActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const CardBodyWrapper = styled.div`
  padding: 1em;
`;
